import type { Story } from '../data'
import { storyRenderMode } from './render-mode'

export function conversionUnavailableText(story: Story): string {
  if (story.conversionStatus === 'experimental_unverified') return '이 동화는 개발용 실험 변환만 가능하며 내용 정확도와 목소리 품질을 검증하지 않았어요. 개발 환경에서만 사용할 수 있어요.'
  if (story.conversionStatus === 'quality_unverified') return story.conversionUnavailableReason || '변환 사용 허가는 등록됐지만, 이 원본의 변환 품질을 검증하고 있어요.'
  if (story.conversionStatus === 'quality_failed') return story.conversionUnavailableReason || '변환 사용 허가는 등록됐지만, 현재 품질 검수에서 오류가 확인되어 제작을 잠시 멈췄어요.'
  if (storyRenderMode(story) === 'renarration') {
    if (story.conversionStatus === 'rights_unconfirmed') return '이 동화의 대본을 다시 읽는 데 필요한 사용 허가가 등록되지 않았어요. 원본 듣기는 가능하지만 확인되기 전까지 새로 읽을 수 없어요.'
    return story.conversionUnavailableReason || '이 동화의 대본을 다시 읽을 준비를 하고 있어요.'
  }
  if (story.conversionStatus === 'rights_unconfirmed') {
    return '이 원본은 목소리 변환에 필요한 사용 허가가 등록되지 않았어요. 원본 듣기는 가능하지만 허가가 확인되기 전까지 변환할 수 없어요.'
  }
  return story.conversionUnavailableReason || '이 동화는 아직 목소리 변환을 준비하고 있어요.'
}
